<template>
  <div id="label-management" class="h-full">
    <el-card class="h-full !pt-0">
      <!-- input输入框部分 -->
      <div class="head mb-20px mx-10px">
        <el-input v-model="labelCode" class="mr-10px" placeholder="标签编码" clearable></el-input>
        <el-input v-model="labelName" class="mr-10px" placeholder="标签名称" clearable></el-input>
        <!-- button按钮部分 -->
        <el-button type="primary" @click="searchLabelList" :disabled="!$hasAccess('read')"
          >搜索</el-button
        >
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="operate('create')" :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button type="danger" @click="batchDetele" :disabled="!$hasAccess('delete')"
          >删除</el-button
        >
      </div>
      <!-- 列表 -->
      <div class="mx-10px h-[calc(100%-105px)]">
        <el-table
          :data="tableData"
          v-loading="labelLoading"
          row-key="id"
          border
          height="100%"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" sortable></el-table-column>
          <el-table-column prop="seqNo" label="序号" width="70"></el-table-column>
          <el-table-column
            prop="code"
            label="编码"
            show-overflow-tooltip
            sortable
          ></el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            show-overflow-tooltip
            sortable
          ></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="{ row }">
              <el-button @click="operate('read', row)" size="mini" :disabled="!$hasAccess('read')"
                >查看</el-button
              >
              <el-button
                @click="operate('update', row)"
                size="mini"
                :disabled="!$hasAccess('update')"
                >编辑</el-button
              >
              <el-button @click="deleteLabel(row)" size="mini" :disabled="!$hasAccess('delete')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mt-20px flex justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="getLabelList"
          :current-page.sync="page.pageNo"
          :page-sizes="pageSizeAll"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-card>
    <AddLabel
      :visible.sync="createVisible"
      :operateProps="operateProps"
      :operateType="operateType"
      @refresh="getLabelList"
    ></AddLabel>
  </div>
</template>

<script>
import { LableApi } from '@wiz-api/cloud-render-management'

const labelApi = new LableApi()
const AddLabel = () => {
  return import('../components/LabelManagement/AddLabel')
}
export default {
  components: {
    AddLabel,
  },
  data() {
    return {
      labelCode: '',
      labelName: '',
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      labelLoading: false,
      selectIds: [],
      pageSizeAll: [15, 30, 45, 60, 75, 90],
      createVisible: false,
      operateType: 'create',
      operateProps: {},
    }
  },
  async created() {
    this.labelLoading = true
    await this.getLabelList()
    this.labelLoading = false
  },
  methods: {
    // 获取标签列表
    async getLabelList() {
      const [err, res] = await labelApi.getList({
        name: this.labelName,
        code: this.labelCode,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      if (!err && res) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    // 搜索
    searchLabelList() {
      this.page.pageNo = 1
      this.getLabelList()
    },
    // 重置表单数据
    reset() {
      this.labelCode = ''
      this.labelName = ''
    },
    // 操作
    operate(type, row) {
      this.operateType = type
      this.createVisible = true
      switch (type) {
        case 'create':
          this.operateProps = {}
          break
        case 'update':
          this.operateProps = row
          break
        case 'read':
          this.operateProps = row
          break
        default:
          break
      }
    },
    deleteLabel(row) {
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await labelApi.callDelete(row.id)
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getLabelList()
        }
      })
    },
    // 批量删除
    async batchDetele() {
      if (!this.selectIds.length) {
        return this.$message({
          showClose: true,
          message: '请勾选要删除的标签',
          type: 'warning',
        })
      }
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await labelApi.deleteMany({
          ids: this.selectIds,
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getLabelList()
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.getLabelList()
    },
    handleSelectionChange(val) {
      this.selectIds = _.map(val, (item) => {
        return item.id
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#label-management {
  .head {
    ::v-deep .el-input {
      width: 200px;
    }
  }
  ::v-deep .el-card__body {
    height: 100%;
  }
}
</style>
